export const hourArrayItems: any = [
  {
    id: 1,
    title: '9:00',
    active: false,
  },
  {
    id: 2,
    title: '10:00',
    active: false,
  },
  {
    id: 3,
    title: '11:00',
    active: false,
  },
  {
    id: 4,
    title: '12:00',
    active: false,
  },
  {
    id: 5,
    title: '13:00',
    active: false,
  },
  {
    id: 6,
    title: '14:00',
    active: false,
  },
  {
    id: 7,
    title: '15:00',
    active: false,
  },
  {
    id: 8,
    title: '16:00',
    active: false,
  },
  {
    id: 9,
    title: '17:00',
    active: false,
  },
  {
    id: 10,
    title: '18:00',
    active: false,
  },
  {
    id: 11,
    title: '19:00',
    active: false,
  },
  {
    id: 12,
    title: '20:00',
    active: false,
  },
];

export const hourArrayItemsForBooking: any = [
  {
    id: 1,
    title: '9:00',
    hour: 9,
    active: false,
  },
  {
    id: 2,
    title: '10:00',
    hour: 10,
    active: false,
  },
  {
    id: 3,
    title: '11:00',
    hour: 11,
    active: false,
  },
  {
    id: 4,
    title: '12:00',
    hour: 12,
    active: false,
  },
  {
    id: 5,
    hour: 13,
    title: '13:00',
    active: false,
  },
  {
    id: 6,
    hour: 14,
    title: '14:00',
    active: false,
  },
  {
    id: 7,
    title: '15:00',
    hour: 15,
    active: false,
  },
  {
    id: 8,
    title: '16:00',
    hour: 16,
    active: false,
  },
  {
    id: 9,
    hour: 17,
    title: '17:00',
    active: false,
  },
  {
    id: 10,
    hour: 18,
    title: '18:00',
    active: false,
  },
  {
    id: 11,
    title: '19:00',
    hour: 19,
    active: false,
  },
];
